import { useCallback, useEffect, useRef, useState } from 'react'

/** Copiar al portapapeles con estado "Copiado" durante 2,5 s (visor de código, dirección de "Cómo llegar"). */
export function useCopy(resetMs = 2500) {
  const [copied, setCopied] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  useEffect(() => () => clearTimeout(timer.current), [])
  const copy = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text)
        setCopied(true)
        clearTimeout(timer.current)
        timer.current = setTimeout(() => setCopied(false), resetMs)
      } catch {
        setCopied(false)
      }
    },
    [resetMs],
  )
  return { copied, copy }
}
